module.exports = __webpack_public_path__ + "007ad31a53f4ab3f58ee74f2308482ce.woff2";